module.exports = __webpack_public_path__ + "static/media/size_before.9d86cec6.svg";